import { FC, HTMLAttributes, ReactNode } from "react";
import S from "./index.module.scss";
import clsx from "clsx";

interface IContainer extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

export const Container: FC<IContainer> = ({ children, className, ...props }) => {
  return (
    <div className={clsx(S.container, className)} {...props}>
      {children}
    </div>
  );
};
